<template>
    <ies-form-field :field="field">
        <v-autocomplete dense outlined
            v-model="viewValue"
            :items="boardBases"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>
</template>

<script>
    export default {
        name: 'ies-input-board-basis-key',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                boardBases: [],
                viewValue: parseInt(this.field.value),
            }
        },
        mounted() {
            axios.get('/api/board-bases')
                .then(function (response) {
                    this.boardBases = response.data.map(function (boardBasis) {
                        return {
                            text: boardBasis.name,
                            value: boardBasis.board_basis_key,
                        };
                    });
                }.bind(this))
                .catch(function (error) {
                    console.error('Failed to load board bases', error);
                });
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>
